export default __webpack_public_path__ + "static/media/a037-student-t3-2.cf2feca1.svg";